import { Moco } from '../model/product'
import { AfaMoco } from '../model/afa'

export const hasTransitionsBadge = (moco: Moco | AfaMoco) =>
  moco.sizes && Object.values(moco.sizes).some(size => size.hasTransitionsBadge)
